import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { hasPermission } from '../../lib/permissions'
import { Permissions } from '../../constants/permissions'

export const useIsAdmin = (): boolean => {
  const sessionData = useSelector((state: any) => state.session?.sessionData)

  return useMemo(
    () => hasPermission(sessionData?.permissionsWithScope, Permissions.ACCESS_ADMIN),
    [sessionData?.permissionsWithScope],
  )
}
